import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Calendar, Clock } from "lucide-react";

export default function Programa() {
  const [events, setEvents] = useState([]);
  const [intro, setIntro] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/events").then((r) => setEvents(r.data)),
      api.get("/content/programa_intro").then((r) => setIntro(r.data.data?.body || "")),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-muted-foreground">Cargando programa…</div>;

  return (
    <div className="space-y-6 animate-in fade-in duration-500" data-testid="programa-page">
      <header className="py-4">
        <div className="text-xs uppercase tracking-[0.25em] text-primary font-bold">Programa</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">Agenda de la Feria</h1>
        {intro && <p className="text-muted-foreground mt-3">{intro}</p>}
      </header>

      {events.length === 0 ? (
        <div className="bg-white rounded-2xl border border-border p-6 text-muted-foreground">
          Próximamente publicaremos la agenda completa.
        </div>
      ) : (
        <ul className="space-y-3" data-testid="events-list">
          {events.map((ev) => (
            <li key={ev.id} className="bg-white rounded-2xl border border-border p-5" data-testid={`event-${ev.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <div className="font-display font-black text-xl">{ev.title}</div>
                  {ev.description && <p className="text-sm text-muted-foreground mt-1">{ev.description}</p>}
                  {ev.location && <p className="text-sm text-muted-foreground mt-1">{ev.location}</p>}
                  <div className="flex flex-wrap gap-2 mt-2">
                    {ev.category && <span className="text-xs font-bold bg-accent px-2 py-1 rounded-full">{ev.category}</span>}
                    {ev.status === "pending_confirmation" && (
                      <span className="text-xs font-bold bg-amber-100 text-amber-800 px-2 py-1 rounded-full">
                        Pendiente de confirmar
                      </span>
                    )}
                  </div>
                </div>
                <div className="shrink-0 text-right">
                  {ev.date && (
                    <div className="inline-flex items-center gap-1 text-xs font-bold bg-accent px-2 py-1 rounded-full">
                      <Calendar size={12} /> {ev.date}
                    </div>
                  )}
                  {ev.time && (
                    <div className="inline-flex items-center gap-1 text-xs text-muted-foreground mt-1">
                      <Clock size={12} /> {ev.time}
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
